/**
 * Marketing-consent lead subscribe for Wall Visualizer, Request Info, and Contact.
 * Client Subscriptions API → Email List XWC2KN (single opt-in).
 *
 * NEVER fires Collector Guide Downloaded / metric W9JqQT.
 * NEVER sets collector_guide, signup_source: collector-guide, or Shopify tag collector-guide.
 * NEVER touches SMS / Text Messaging List R2NfL4.
 */
(function (root) {
  'use strict';

  var KLAVIYO_REVISION = '2024-10-15';
  var DEFAULT_COMPANY_ID = 'Wy9UTz';
  var DEFAULT_LIST_ID = 'XWC2KN';
  var FORBIDDEN_LIST_ID = 'R2NfL4';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var CUSTOM_SOURCE_BY_LEAD = {
    wall_visualizer: 'Wall Visualizer',
    request_info: 'Request Info',
    contact_form: 'Contact Form'
  };

  function companyIdFromPage() {
    try {
      var doc = root.document;
      var scripts = doc && doc.querySelectorAll ? doc.querySelectorAll('script[src*="klaviyo"]') : [];
      for (var i = 0; i < scripts.length; i++) {
        var src = scripts[i].getAttribute('src') || '';
        var match = src.match(/company_id=([A-Za-z0-9]+)/);
        if (match) return match[1];
      }
    } catch (e) {}
    return '';
  }

  function resolveCompanyId(opts) {
    var cfg = root.__gwfineKlaviyoLead || {};
    return String((opts && opts.companyId) || cfg.companyId || companyIdFromPage() || DEFAULT_COMPANY_ID).trim();
  }

  function resolveListId(opts) {
    var cfg = root.__gwfineKlaviyoLead || {};
    var listId = String((opts && opts.listId) || cfg.listId || DEFAULT_LIST_ID).trim();
    if (!listId) listId = DEFAULT_LIST_ID;
    if (listId === FORBIDDEN_LIST_ID) return '';
    return listId;
  }

  function klaviyoHeaders() {
    return {
      'Content-Type': 'application/vnd.api+json',
      Accept: 'application/vnd.api+json',
      revision: KLAVIYO_REVISION
    };
  }

  function isTruthyConsent(value) {
    if (value === true) return true;
    if (typeof value === 'string') {
      var v = value.trim().toLowerCase();
      return v === 'yes' || v === 'true' || v === '1';
    }
    return false;
  }

  function gwfineSubscribeLeadEmail(opts) {
    opts = opts || {};
    if (!isTruthyConsent(opts.marketingConsent)) {
      return Promise.resolve({ ok: true, skipped: true, reason: 'no-marketing-consent' });
    }

    var email = String(opts.email || '').trim();
    if (!EMAIL_RE.test(email)) {
      return Promise.resolve({ ok: false, skipped: true, reason: 'invalid-email' });
    }

    var leadSource = String(opts.leadSource || '').trim();
    if (!CUSTOM_SOURCE_BY_LEAD[leadSource]) {
      return Promise.resolve({ ok: false, skipped: true, reason: 'invalid-lead-source' });
    }

    var companyId = resolveCompanyId(opts);
    var listId = resolveListId(opts);
    if (!companyId || !listId) {
      return Promise.resolve({ ok: false, skipped: true, reason: 'missing-klaviyo-ids' });
    }

    var firstName = String(opts.firstName || '').trim();
    var lastName = String(opts.lastName || '').trim();
    var customSource = String(opts.customSource || CUSTOM_SOURCE_BY_LEAD[leadSource]).trim();

    var profileAttributes = {
      email: email,
      properties: {
        lead_source: leadSource
      }
    };
    if (firstName) profileAttributes.first_name = firstName;
    if (lastName) profileAttributes.last_name = lastName;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId }
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: klaviyoHeaders(),
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res && (res.ok || res.status === 202)) {
        return { ok: true, status: res.status };
      }
      throw new Error('subscribe ' + (res && res.status));
    });
  }

  root.gwfineSubscribeLeadEmail = gwfineSubscribeLeadEmail;
})(typeof window !== 'undefined' ? window : globalThis);
